import React from "react";

interface IProps {
  theme: "light" | "dark";
}

export const PlayIcon = ({ theme }: IProps) => {
  return (
    <div>
      {theme === "light" ? (
        <svg
          width="55"
          height="55"
          viewBox="0 0 55 55"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.64 1C12.9235 1 1 12.9235 1 27.64C1 42.3564 12.9235 54.28 27.64 54.28C42.3564 54.28 54.28 42.3564 54.28 27.64C54.28 12.9235 42.3564 1 27.64 1ZM40.0684 30.2181L21.1626 41.0674C19.4654 42.0127 17.3277 40.7989 17.3277 38.8116V16.4684C17.3277 14.4919 19.4546 13.2673 21.1626 14.2126L40.0684 25.7064C41.8301 26.6947 41.8301 29.2405 40.0684 30.2181Z"
            fill="#1A7AB5"
          />
        </svg>
      ) : (
        <svg
          width="54"
          height="54"
          viewBox="0 0 54 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.64 0C11.9235 0 0 11.9235 0 26.64C0 41.3564 11.9235 53.28 26.64 53.28C41.3564 53.28 53.28 41.3564 53.28 26.64C53.28 11.9235 41.3564 0 26.64 0ZM39.0684 29.2181L20.1626 40.0674C18.4654 41.0127 16.3277 39.7989 16.3277 37.8116V15.4684C16.3277 13.4919 18.4546 12.2673 20.1626 13.2126L39.0684 24.7064C40.8301 25.6947 40.8301 28.2405 39.0684 29.2181Z"
            fill="#329EE2"
          />
        </svg>
      )}
    </div>
  );
};
